import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
// @ts-nocheck
import { getSplitToggle } from './split';
export var initToggle = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(country) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSplitToggle(country);

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initToggle(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getToggle = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(country) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!window.addiFeatureToggles) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", window.addiFeatureToggles);

          case 4:
            _context2.next = 6;
            return initToggle(country);

          case 6:
            window.addiFeatureToggles = _context2.sent;
            return _context2.abrupt("return", window.addiFeatureToggles);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getToggle(_x2) {
    return _ref2.apply(this, arguments);
  };
}();